import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  memo,
  ReactNode,
} from "react";
import { initialNodePositionsById } from "../../utilities/Nodes/getConnectedChildNodes";

const NodesPositionContext = createContext<any>({
    nodesPositionMap: {},
    onNodeDrag: (changes: any) => {},
		updateNodesPosition: (nextValues: any, type?: string) => {},
});
export const useNodesPositionContext = () => useContext(NodesPositionContext);

const NodesPositionProvider = ({ children }: { children: ReactNode }) => {
  const flow_type = sessionStorage.getItem("flow_type") || "";

  const [nodesPositionMap, setNodesPositionMap] = useState<any>(
    initialNodePositionsById[flow_type]
  );

  const handleOnNodeDrag = useCallback((changes: any) => {
    const draggedNode = changes[0];
    if (draggedNode?.position)
      setNodesPositionMap((current: any) => ({
        ...current,
        [draggedNode?.id]: draggedNode?.position,
      }));
  }, []);

	const handleOnNodePositionUpdate = useCallback((nextValues: any, type: string = 'update') => {
		if (type === 'replace') {
			setNodesPositionMap(nextValues)
		} else {
			setNodesPositionMap((current: any) => ({
				...current,
				...nextValues,
			}));
		}
	}, []);

  const handleOndeleteChildPsoitions = useCallback((nodeIds: string[]) => {
    setNodesPositionMap((current: any) => {
      const updatedNodePositions = { ...current };
      nodeIds.forEach((nodeId) => {
        delete updatedNodePositions[nodeId];
      });
      return updatedNodePositions;
    });
  }
  , []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextValue = useMemo(
    () => ({
      nodesPositionMap,
      onNodeDrag: handleOnNodeDrag,
			updateNodesPosition: handleOnNodePositionUpdate,
      deleteChildPsoitions: handleOndeleteChildPsoitions,
    }),
    [handleOnNodeDrag, handleOnNodePositionUpdate, handleOndeleteChildPsoitions, nodesPositionMap]
  );

  return (
    <NodesPositionContext.Provider value={contextValue}>
      {children}
    </NodesPositionContext.Provider>
  );
};

export default memo(NodesPositionProvider);
